import Market from './root.vue'
import MainNav from './main_nav.vue'
import MemberDay from './member_day/router'
import RechargeDelivery from './recharge_delivery/router'
import MemberPoints from './member_points/router'

const route = {
    path: 'market',
    component: Market,
    children: [{
        path: '',
        redirect: 'nav'
    }, {
        path: 'nav',
        component: MainNav,
        children: [{
            path: '',
            redirect: RechargeDelivery.path
        },
            // MemberDay,
            RechargeDelivery,
            MemberPoints
        ]
    }]
}

export default route
